import { useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";

export function ConvenantValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    phone: Yup.string()
      .required(t("LABEL.required"))
      .test("is-valid-phone", t("LABEL.invalid phone"), (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value);
      }),
    commission: Yup.string().optional(),
  });

  return validation;
}
